const _excluded = ["setEnabled"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { fetchWithTokenAndRegion, getAdminConstructionApiUrl, getCurrentToken, getCurrentTokenWithoutRedirect, getOxygenId } from '@adsk/acs-sc-web-platform-api';
import { useSWRAlloy, CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
/**
 * Context for current user subscriptions construction version.
 */
const SubscriptionsConstructionContext = getOrCreateGlobalContext(CONTEXT_NAMES.SubscriptionsConstructionContext);
const useSubscriptionsConstructionContext = () => useContextWithValidation(SubscriptionsConstructionContext, {
  hook: 'useSubscriptionsConstruction',
  provider: 'SubscriptionsConstructionProvider'
});
export const useSubscriptionsConstruction = function () {
  let enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const _useSubscriptionsCons = useSubscriptionsConstructionContext(),
    {
      setEnabled
    } = _useSubscriptionsCons,
    rest = _objectWithoutProperties(_useSubscriptionsCons, _excluded);
  useEffect(() => {
    if (enable && setEnabled) {
      setEnabled(true);
    }
  }, [setEnabled, enable]);
  return rest;
};
const fetchConstructionSubscriptions = () => getCurrentToken().then(_ref => {
  let {
    accessToken
  } = _ref;
  const oxygenId = getOxygenId(accessToken);
  return fetchWithTokenAndRegion("".concat(getAdminConstructionApiUrl(), "/internal/v1/users/").concat(oxygenId, "/subscriptions?filter[status]=active,expired"));
});
export const SubscriptionsConstructionProvider = _ref2 => {
  let {
    children
  } = _ref2;
  const [enabled, setEnabled] = useState(false);
  const {
    data: fetchData,
    error,
    revalidate: retry
  } = useSWRAlloy(enabled ? '/current_user_subscriptions_construction' : null, () => getCurrentTokenWithoutRedirect().then(() => fetchConstructionSubscriptions()));
  const data = (error === null || error === void 0 ? void 0 : error.status) === 401 ? null : fetchData;
  const loading = !data && !error;
  const setEnabledValue = useMemo(() => {
    if (enabled) return undefined;
    return setEnabled;
  }, [enabled, setEnabled]);
  return /*#__PURE__*/React.createElement(SubscriptionsConstructionContext.Provider, {
    value: {
      error,
      loading,
      data: data === null || data === void 0 ? void 0 : data.results,
      retry,
      setEnabled: setEnabledValue
    }
  }, children);
};
SubscriptionsConstructionProvider.displayName = 'SubscriptionsConstructionProvider';
SubscriptionsConstructionProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node
};
//# sourceMappingURL=SubscriptionsConstructionContext.js.map